import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

type SettingsMap = Record<string, any>;

let cache: SettingsMap | null = null;
const listeners = new Set<(s: SettingsMap) => void>();

const load = async () => {
  const { data } = await supabase.from("settings").select("key, value");
  const map: SettingsMap = {};
  data?.forEach((row) => {
    map[row.key] = row.value;
  });
  cache = map;
  listeners.forEach((l) => l(map));
  return map;
};

export const refreshSettings = () => load();

export const useSettings = () => {
  const [settings, setSettings] = useState<SettingsMap>(cache ?? {});
  useEffect(() => {
    if (!cache) load();
    const listener = (s: SettingsMap) => setSettings(s);
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  }, []);
  return settings;
};
